import { Box, Collapse, Typography } from '@mui/material';
import { ChevronDown, ChevronUp } from '@assets/svgs';
import { ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  count?: number;
}

export const CollapsibleSection = ({ title, isExpanded, onToggle, children, count }: CollapsibleSectionProps) => {
  return (
    <Box>
      <Box
        role='button'
        tabIndex={0}
        aria-expanded={isExpanded}
        aria-label={`${isExpanded ? 'Collapse' : 'Expand'} ${title} section`}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          py: 1,
          px: 2,
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Typography variant='subtitle2' fontWeight={600}>
          {title}
          {count !== undefined && ` (${count})`}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isExpanded ? <ChevronUp width='12px' height='12px' /> : <ChevronDown width='12px' height='12px' />}
        </Box>
      </Box>
      <Collapse in={isExpanded}>
        <Box>{children}</Box>
      </Collapse>
    </Box>
  );
};
